// @generated by protoc-gen-es v2.14.0 with parameter "target=ts,import_extension=js"
// @generated from file puzzle/v1/common.proto (package puzzle.v1, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
/**
 * Describes the file puzzle/v1/common.proto.
 */
export const file_puzzle_v1_common = /*@__PURE__*/ fileDesc("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");
/**
 * Describes the message puzzle.v1.CampaignLandmark.
 * Use `create(CampaignLandmarkSchema)` to create a new message.
 */
export const CampaignLandmarkSchema = /*@__PURE__*/ messageDesc(file_puzzle_v1_common, 0);
/**
 * Describes the message puzzle.v1.CampaignPlaythroughProjection.
 * Use `create(CampaignPlaythroughProjectionSchema)` to create a new message.
 */
export const CampaignPlaythroughProjectionSchema = /*@__PURE__*/ messageDesc(file_puzzle_v1_common, 1);
/**
 * @generated from enum puzzle.v1.RoomStage
 */
export var RoomStage;
(function (RoomStage) {
    /**
     * @generated from enum value: ROOM_STAGE_UNSPECIFIED = 0;
     */
    RoomStage[RoomStage["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: ROOM_STAGE_LOBBY = 1;
     */
    RoomStage[RoomStage["LOBBY"] = 1] = "LOBBY";
    /**
     * @generated from enum value: ROOM_STAGE_GAME = 2;
     */
    RoomStage[RoomStage["GAME"] = 2] = "GAME";
    /**
     * @generated from enum value: ROOM_STAGE_RESULTS = 3;
     */
    RoomStage[RoomStage["RESULTS"] = 3] = "RESULTS";
    /**
     * @generated from enum value: ROOM_STAGE_ENDED = 4;
     */
    RoomStage[RoomStage["ENDED"] = 4] = "ENDED";
})(RoomStage || (RoomStage = {}));
/**
 * Describes the enum puzzle.v1.RoomStage.
 */
export const RoomStageSchema = /*@__PURE__*/ enumDesc(file_puzzle_v1_common, 0);
/**
 * @generated from enum puzzle.v1.RoomVisibility
 */
export var RoomVisibility;
(function (RoomVisibility) {
    /**
     * @generated from enum value: ROOM_VISIBILITY_UNSPECIFIED = 0;
     */
    RoomVisibility[RoomVisibility["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: ROOM_VISIBILITY_PUBLIC = 1;
     */
    RoomVisibility[RoomVisibility["PUBLIC"] = 1] = "PUBLIC";
    /**
     * @generated from enum value: ROOM_VISIBILITY_PRIVATE = 2;
     */
    RoomVisibility[RoomVisibility["PRIVATE"] = 2] = "PRIVATE";
})(RoomVisibility || (RoomVisibility = {}));
/**
 * Describes the enum puzzle.v1.RoomVisibility.
 */
export const RoomVisibilitySchema = /*@__PURE__*/ enumDesc(file_puzzle_v1_common, 1);
/**
 * @generated from enum puzzle.v1.PieceSpawnMode
 */
export var PieceSpawnMode;
(function (PieceSpawnMode) {
    /**
     * @generated from enum value: PIECE_SPAWN_MODE_UNSPECIFIED = 0;
     */
    PieceSpawnMode[PieceSpawnMode["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: PIECE_SPAWN_MODE_EDGES = 1;
     */
    PieceSpawnMode[PieceSpawnMode["EDGES"] = 1] = "EDGES";
    /**
     * @generated from enum value: PIECE_SPAWN_MODE_SCATTERED = 2;
     */
    PieceSpawnMode[PieceSpawnMode["SCATTERED"] = 2] = "SCATTERED";
    /**
     * @generated from enum value: PIECE_SPAWN_MODE_RING = 3;
     */
    PieceSpawnMode[PieceSpawnMode["RING"] = 3] = "RING";
})(PieceSpawnMode || (PieceSpawnMode = {}));
/**
 * Describes the enum puzzle.v1.PieceSpawnMode.
 */
export const PieceSpawnModeSchema = /*@__PURE__*/ enumDesc(file_puzzle_v1_common, 2);
/**
 * @generated from enum puzzle.v1.PieceRotationMode
 */
export var PieceRotationMode;
(function (PieceRotationMode) {
    /**
     * @generated from enum value: PIECE_ROTATION_MODE_UNSPECIFIED = 0;
     */
    PieceRotationMode[PieceRotationMode["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: PIECE_ROTATION_MODE_UPRIGHT = 1;
     */
    PieceRotationMode[PieceRotationMode["UPRIGHT"] = 1] = "UPRIGHT";
    /**
     * @generated from enum value: PIECE_ROTATION_MODE_ROTATED = 2;
     */
    PieceRotationMode[PieceRotationMode["ROTATED"] = 2] = "ROTATED";
})(PieceRotationMode || (PieceRotationMode = {}));
/**
 * Describes the enum puzzle.v1.PieceRotationMode.
 */
export const PieceRotationModeSchema = /*@__PURE__*/ enumDesc(file_puzzle_v1_common, 3);
/**
 * @generated from enum puzzle.v1.RoomRole
 */
export var RoomRole;
(function (RoomRole) {
    /**
     * @generated from enum value: ROOM_ROLE_UNSPECIFIED = 0;
     */
    RoomRole[RoomRole["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: ROOM_ROLE_PLAYER = 1;
     */
    RoomRole[RoomRole["PLAYER"] = 1] = "PLAYER";
    /**
     * @generated from enum value: ROOM_ROLE_SPECTATOR = 2;
     */
    RoomRole[RoomRole["SPECTATOR"] = 2] = "SPECTATOR";
})(RoomRole || (RoomRole = {}));
/**
 * Describes the enum puzzle.v1.RoomRole.
 */
export const RoomRoleSchema = /*@__PURE__*/ enumDesc(file_puzzle_v1_common, 4);
/**
 * @generated from enum puzzle.v1.RoomMemberPresence
 */
export var RoomMemberPresence;
(function (RoomMemberPresence) {
    /**
     * @generated from enum value: ROOM_MEMBER_PRESENCE_UNSPECIFIED = 0;
     */
    RoomMemberPresence[RoomMemberPresence["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: ROOM_MEMBER_PRESENCE_CONNECTED = 1;
     */
    RoomMemberPresence[RoomMemberPresence["CONNECTED"] = 1] = "CONNECTED";
    /**
     * @generated from enum value: ROOM_MEMBER_PRESENCE_RECONNECTING = 2;
     */
    RoomMemberPresence[RoomMemberPresence["RECONNECTING"] = 2] = "RECONNECTING";
    /**
     * @generated from enum value: ROOM_MEMBER_PRESENCE_OFFLINE = 3;
     */
    RoomMemberPresence[RoomMemberPresence["OFFLINE"] = 3] = "OFFLINE";
})(RoomMemberPresence || (RoomMemberPresence = {}));
/**
 * Describes the enum puzzle.v1.RoomMemberPresence.
 */
export const RoomMemberPresenceSchema = /*@__PURE__*/ enumDesc(file_puzzle_v1_common, 5);
/**
 * @generated from enum puzzle.v1.RoomSettingsScope
 */
export var RoomSettingsScope;
(function (RoomSettingsScope) {
    /**
     * @generated from enum value: ROOM_SETTINGS_SCOPE_UNSPECIFIED = 0;
     */
    RoomSettingsScope[RoomSettingsScope["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: ROOM_SETTINGS_SCOPE_LOBBY = 1;
     */
    RoomSettingsScope[RoomSettingsScope["LOBBY"] = 1] = "LOBBY";
    /**
     * @generated from enum value: ROOM_SETTINGS_SCOPE_GAME = 2;
     */
    RoomSettingsScope[RoomSettingsScope["GAME"] = 2] = "GAME";
    /**
     * @generated from enum value: ROOM_SETTINGS_SCOPE_GAME_PLAN = 3;
     */
    RoomSettingsScope[RoomSettingsScope["GAME_PLAN"] = 3] = "GAME_PLAN";
})(RoomSettingsScope || (RoomSettingsScope = {}));
/**
 * Describes the enum puzzle.v1.RoomSettingsScope.
 */
export const RoomSettingsScopeSchema = /*@__PURE__*/ enumDesc(file_puzzle_v1_common, 6);
/**
 * @generated from enum puzzle.v1.PuzzleShape
 */
export var PuzzleShape;
(function (PuzzleShape) {
    /**
     * @generated from enum value: PUZZLE_SHAPE_UNSPECIFIED = 0;
     */
    PuzzleShape[PuzzleShape["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: PUZZLE_SHAPE_RECTANGLE = 1;
     */
    PuzzleShape[PuzzleShape["RECTANGLE"] = 1] = "RECTANGLE";
    /**
     * @generated from enum value: PUZZLE_SHAPE_ALPHA = 2;
     */
    PuzzleShape[PuzzleShape["ALPHA"] = 2] = "ALPHA";
})(PuzzleShape || (PuzzleShape = {}));
/**
 * Describes the enum puzzle.v1.PuzzleShape.
 */
export const PuzzleShapeSchema = /*@__PURE__*/ enumDesc(file_puzzle_v1_common, 7);
/**
 * @generated from enum puzzle.v1.PuzzleCutMode
 */
export var PuzzleCutMode;
(function (PuzzleCutMode) {
    /**
     * @generated from enum value: PUZZLE_CUT_MODE_UNSPECIFIED = 0;
     */
    PuzzleCutMode[PuzzleCutMode["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: PUZZLE_CUT_MODE_GRID = 1;
     */
    PuzzleCutMode[PuzzleCutMode["GRID"] = 1] = "GRID";
    /**
     * @generated from enum value: PUZZLE_CUT_MODE_MORPHED = 2;
     */
    PuzzleCutMode[PuzzleCutMode["MORPHED"] = 2] = "MORPHED";
})(PuzzleCutMode || (PuzzleCutMode = {}));
/**
 * Describes the enum puzzle.v1.PuzzleCutMode.
 */
export const PuzzleCutModeSchema = /*@__PURE__*/ enumDesc(file_puzzle_v1_common, 8);
/**
 * @generated from enum puzzle.v1.CursorSkin
 */
export var CursorSkin;
(function (CursorSkin) {
    /**
     * @generated from enum value: CURSOR_SKIN_UNSPECIFIED = 0;
     */
    CursorSkin[CursorSkin["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: CURSOR_SKIN_NOVA = 1;
     */
    CursorSkin[CursorSkin["NOVA"] = 1] = "NOVA";
    /**
     * @generated from enum value: CURSOR_SKIN_COMET = 2;
     */
    CursorSkin[CursorSkin["COMET"] = 2] = "COMET";
    /**
     * @generated from enum value: CURSOR_SKIN_ORBIT = 3;
     */
    CursorSkin[CursorSkin["ORBIT"] = 3] = "ORBIT";
    /**
     * @generated from enum value: CURSOR_SKIN_PRISM = 4;
     */
    CursorSkin[CursorSkin["PRISM"] = 4] = "PRISM";
})(CursorSkin || (CursorSkin = {}));
/**
 * Describes the enum puzzle.v1.CursorSkin.
 */
export const CursorSkinSchema = /*@__PURE__*/ enumDesc(file_puzzle_v1_common, 9);
/**
 * @generated from enum puzzle.v1.ConversationRemovedBy
 */
export var ConversationRemovedBy;
(function (ConversationRemovedBy) {
    /**
     * @generated from enum value: CONVERSATION_REMOVED_BY_UNSPECIFIED = 0;
     */
    ConversationRemovedBy[ConversationRemovedBy["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: CONVERSATION_REMOVED_BY_AUTHOR = 1;
     */
    ConversationRemovedBy[ConversationRemovedBy["AUTHOR"] = 1] = "AUTHOR";
    /**
     * @generated from enum value: CONVERSATION_REMOVED_BY_HOST = 2;
     */
    ConversationRemovedBy[ConversationRemovedBy["HOST"] = 2] = "HOST";
})(ConversationRemovedBy || (ConversationRemovedBy = {}));
/**
 * Describes the enum puzzle.v1.ConversationRemovedBy.
 */
export const ConversationRemovedBySchema = /*@__PURE__*/ enumDesc(file_puzzle_v1_common, 10);
//# sourceMappingURL=common_pb.js.map